module.exports = __webpack_public_path__ + "img/logo-brest.1a54313a.png";